/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Furniture_CategoryInputs */

const en_field_furniture_category = /** @type {(inputs: Field_Furniture_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const es_field_furniture_category = /** @type {(inputs: Field_Furniture_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoría`)
};

const fr_field_furniture_category = /** @type {(inputs: Field_Furniture_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catégorie`)
};

const de_field_furniture_category = /** @type {(inputs: Field_Furniture_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie`)
};

const ja_field_furniture_category = /** @type {(inputs: Field_Furniture_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`家具のカテゴリ`)
};

const zh_field_furniture_category = /** @type {(inputs: Field_Furniture_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类别`)
};

const ar_field_furniture_category = /** @type {(inputs: Field_Furniture_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفئة`)
};

const id_field_furniture_category = /** @type {(inputs: Field_Furniture_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategori`)
};

const it_field_furniture_category = /** @type {(inputs: Field_Furniture_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

const ru_field_furniture_category = /** @type {(inputs: Field_Furniture_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категория мебели`)
};

const pt_field_furniture_category = /** @type {(inputs: Field_Furniture_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categoria`)
};

const ko_field_furniture_category = /** @type {(inputs: Field_Furniture_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카테고리`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Field_Furniture_CategoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_furniture_category = /** @type {((inputs?: Field_Furniture_CategoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Furniture_CategoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_furniture_category(inputs)
	if (locale === "es") return es_field_furniture_category(inputs)
	if (locale === "fr") return fr_field_furniture_category(inputs)
	if (locale === "de") return de_field_furniture_category(inputs)
	if (locale === "ja") return ja_field_furniture_category(inputs)
	if (locale === "zh") return zh_field_furniture_category(inputs)
	if (locale === "ar") return ar_field_furniture_category(inputs)
	if (locale === "id") return id_field_furniture_category(inputs)
	if (locale === "it") return it_field_furniture_category(inputs)
	if (locale === "ru") return ru_field_furniture_category(inputs)
	if (locale === "pt") return pt_field_furniture_category(inputs)
	return ko_field_furniture_category(inputs)
});